import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=6b3c652d&scoped=true&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"
import style0 from "./pricehelp.vue?vue&type=style&index=0&id=6b3c652d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3c652d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b3c652d')) {
      api.createRecord('6b3c652d', component.options)
    } else {
      api.reload('6b3c652d', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=6b3c652d&scoped=true&", function () {
      api.rerender('6b3c652d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8gORnCsGu15Rv/JS/pricehelp.vue"
export default component.exports